import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=354d35d8&scoped=true&"
import script from "./BaseAlert.vue?vue&type=script&lang=js&"
export * from "./BaseAlert.vue?vue&type=script&lang=js&"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=354d35d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d35d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354d35d8')) {
      api.createRecord('354d35d8', component.options)
    } else {
      api.reload('354d35d8', component.options)
    }
    module.hot.accept("./BaseAlert.vue?vue&type=template&id=354d35d8&scoped=true&", function () {
      api.rerender('354d35d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseAlert.vue"
export default component.exports